import { render, staticRenderFns } from "./DialogDeleteConfirmation.vue?vue&type=template&id=989d8a30&"
import script from "./DialogDeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports